import { render, staticRenderFns } from "./EditTimeBasedChannel.vue?vue&type=template&id=742baabd&"
import script from "./EditTimeBasedChannel.vue?vue&type=script&lang=js&"
export * from "./EditTimeBasedChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports